module.exports = __webpack_public_path__ + "media/qq2.34d80c8e.mp3";